import React, { useEffect, useRef } from 'react';
import {
  IonCol,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useHistory, useLocation } from 'react-router';
import { platformWeb } from '../utils/platform';
import { usePostMessages } from '../PostMessageReceiver';
import { backCompleted } from '../utils/nav';

type AppPageHeaderProps = {
  title: string;
  isPageActive: boolean;
  back?: () => void | Promise<void>;
};

export default function AppPageHeader({
  title,
  back,
  isPageActive,
}: AppPageHeaderProps) {
  const router = useHistory();
  const location = useLocation();
  const isFirstRender = useRef(true);

  const { backCommands } = usePostMessages();

  useEffect(() => {
    if (isFirstRender.current) {
      // Skip the effect on the initial render
      isFirstRender.current = false;
      return;
    }
    if (!isPageActive) {
      // page is not active
      return;
    }
    if (back) {
      callBackMethod();
    }
  }, [backCommands]);

  const callBackMethod = () => {
    if (back) {
      console.log('Trigger back');
      const result = back();
      if (result && typeof result.then === 'function') {
        result.then(() => {
          backCompleted();
          console.log('Back completed async');
        });
      } else {
        backCompleted();
        console.log('Back completed synchronous');
      }
    } else {
      console.log('Back callback not defined');
    }
  };

  const internalGoBack = () => {
    window.postMessage('ionicGoBack', window.location.origin);
  };

  if (!platformWeb()) {
    return null;
  }

  return (
    <IonHeader className="ion-no-border">
      <IonToolbar>
        <IonGrid>
          <IonRow className="ion-align-items-center">
            {back && (
              <IonCol size="auto" onClick={() => internalGoBack()}>
                <IonIcon src="assets/icon/caret-left.svg"></IonIcon>
              </IonCol>
            )}
            <IonCol>
              <IonTitle>{title}</IonTitle>
            </IonCol>
            <IonCol size="auto"></IonCol>
          </IonRow>
        </IonGrid>
      </IonToolbar>
    </IonHeader>
  );
}
